<template>
  <div>
    <v-layout class="mb-2">
      <v-spacer></v-spacer>
      <v-flex shrink>
        <v-btn color="primary" @click="handleExportButtonClick">
          <v-icon>logout</v-icon>
          Export
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="localItems"
      :pagination="localPagination"
      :total-items="localPagination.totalItems"
      hide-actions
      disable-initial-sort
    >
      <template #items="{ item }">
        <td>{{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm:ss') }}</td>
        <td>{{ item.message }}</td>
        <td>{{ item.post_id }}</td>
        <td>
          <SentimentMenu v-model="item.sentiment" @input="() => change('sentiment', item)" />
        </td>
        <td>
          <v-container fluid grid-list-lg class="pa-2" :style="{ width: '100% !important' }">
            <v-layout align-center>
              <!-- <v-flex shrink>
                <v-checkbox
                  v-model="item.checkbox"
                  hide-details
                  @change="() => change('hasRemarked', item)"
                ></v-checkbox>
              </v-flex> -->
              <v-flex class="default-input">
                <v-text-field
                  v-model="item.remark"
                  single-line
                  outline
                  hide-details
                  :style="{ minWidth: '15em' }"
                  @change="() => change('remark', item)"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </td>
      </template>
    </v-data-table>
    <div class="mt-2" :style="{ display: 'flex' }">
      <v-pagination
        v-model="localPagination.page"
        :length="totalPages"
        class="ml-auto"
        @input="handlePaginationInput"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import SentimentMenu from './SentimentMenu.vue'
import ttbApi from '@/api/ttb'
export default {
  components: {
    SentimentMenu
  },
  props: {
    pageid: {
      type: String,
      default: ''
    },
    userid: {
      type: String,
      default: ''
    },
    pagination: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      localItems: [],
      localPagination: {
        totalItems: 0,
        rowsPerPage: 10,
        page: 1
      },
      headers: [
        { text: 'Date & time', value: 'timestamp', sortable: false },
        { text: 'Message', value: 'message', sortable: false },
        { text: 'Post', value: 'post_id', sortable: false },
        { text: 'Sentiment', value: 'sentiment', sortable: false },
        { text: 'Remark', value: 'remark', sortable: false }
      ]
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.localPagination.totalItems / this.localPagination.rowsPerPage)
    }
  },
  watch: {
    items(value) {
      this.localItems = JSON.parse(JSON.stringify(value))
    },
    localPagination: {
      handler() {
        this.handleFetchData()
      },
      deep: true
    }
  },
  mounted() {
    this.handleFetchData()
  },
  methods: {
    async handleFetchData() {
      this.loading = true
      await this.handleGetSentimentByUserId()
      this.loading = false
    },
    async handleGetSentimentByUserId() {
      const response = await ttbApi.getSentimentByUserId({
        params: {
          page_id: this.pageid,
          limit: this.localPagination.rowsPerPage,
          offset: this.localPagination.rowsPerPage * (this.localPagination.page - 1)
        },
        userid: this.userid
      })
      if (response.status === 200) {
        this.localItems = response.data.data || []
        this.localPagination.totalItems = response.data.total
          ? typeof response.data.total == 'string'
            ? parseInt(response.data.total)
            : response.data.total
          : 0
      }
    },
    async change(key, item) {
      const response = await ttbApi.patchSentiment({
        sentimentId: item.id,
        data: {
          ...item,
          page_id: this.pageid
        }
      })
      if (response.status === 200 || response.status === 204) {
        this.$emit('update:items', this.localItems)
        // fetch data again
        this.handleFetchData()
      }
    },
    handleExportButtonClick() {
      this.$emit('export', this.localItems)
    },
    handlePaginationInput() {
      this.$emit('update:pagination', JSON.parse(JSON.stringify(this.localPagination)))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/ReplyComment/UserDataTable.vue